<button class="btn btn-danger" (click)="open()">
    {{countNbr ? countNbr : '0'}}
</button>

<div [@openClose]="isOpen? 'open':'closed'" #drawerContent class="content">
    <div class="dismiss" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
    </div>
    <app-damage-analysis [currentImage]='currentImage' [tchekId]="tchekId" [inPlayer]="true" [currentMode]='currentMode'
        (damageDeleted)="handleDamageDeleted($event)" (damageSelected)="handleDamageSelected($event)">
    </app-damage-analysis>

</div>

<ng-template #noRois>
    <div class="mx-auto text-muted text-center" style="font-size:2em;"
        i18n="roi_drawer|@@no_automatic_rois_from_camera">
        No damages.
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/roi-drawer/roi-drawer.component.html